import React, { ChangeEvent } from "react";
import './Input.css'

interface SelectProps {
	id: string
	label: string
	description?: string
	errorMessage?: string
	isRequired?: boolean
	value: string | undefined
	options: string[]
	onChange: (value: string) => void
	handleBlur?: (e: React.FocusEvent<HTMLSelectElement>) => void
}

const Select: React.FC<SelectProps> = ({
	id,
	label,
	description,
	errorMessage,
	isRequired = false,
	value,
	options,
	onChange,
	handleBlur,
}) => {

	const handleChange = (e: ChangeEvent<HTMLSelectElement>) => {
		onChange(e.target.value)
	}

	return (
		<div className="input-container">
			<p className="input-label">
				<label htmlFor={id}>{label}</label>
				{isRequired && <span className="input-required">*</span>}
			</p>
			{description && <p className="input-description">{description}</p>}
			<select id={id} name={id} onChange={handleChange} onBlur={handleBlur} value={value || ""}>
				<option value="">-- Select a County --</option>
				{options.map((option) => (
					<option key={option} value={option}>
						{option}
					</option>
				))}
			</select>
			<div className="input-error-message">{errorMessage}</div>
		</div>
	)
}

export default Select
